module.exports = __webpack_public_path__ + "static/cadira_orc_female-642a77691427177c678ee6558d1fa459.jpg";